<template>
    <div>
        <div class="top-img">
            <img v-if="locale==='zh'" src="../../static/images/u668.png" alt="">
            <img v-if="locale==='en'" src="../../static/images/e668.png" alt="">
        </div>
        <div class="breadcrumb-div">
            <div class="FL">
                <img src="../../static/images/u177.png" alt="" class="breadcrumb-img">
            </div>
            <div class="FL breadcrumb-title">
                {{ $t('lang.position') }}：
            </div>
            <div class="FL">
                <a-breadcrumb class="breadcrumb-main">
                    <a-breadcrumb-item><a href="/">{{ $t('lang.index1') }}</a></a-breadcrumb-item>
                    <a-breadcrumb-item>{{ $t('lang.contact') }}</a-breadcrumb-item>
                </a-breadcrumb>
            </div>
        </div>
        <div class="main-div MT30">
            <div class="MT30">
                <div class="FL MT30">
                    <navComponent/>
                </div>
                <div class="FR" style="width: 1080px;">
                    <div class="int-title margin-auto font-weight text-align">{{ $t('lang.contact') }}</div>
                    <div class="margin-auto font-weight text-align int-title2">{{ $t('lang.Foot') }}</div>
                    <a-row class="MT30">
                        <a-col :span="16" class="content-list">
                            <img src="../../static/images/u101.png" alt="" class="name-logo">
                            <p class="font-weight name-top" style="font-size: 22px">{{ $t('lang.name') }}</p>
                            <p>{{ $t('lang.add') }}：{{ $t('lang.addInfo') }}</p>
                            <p>{{ $t('lang.contactEr') }}</p>
                            <!--<p>{{ $t('lang.Tel') }}：0536-4683701</p>-->
                            <p>{{ $t('lang.Mobile') }}：151 6566 2714</p>
                            <p>{{ $t('lang.Email') }}：office@bawaytech.com</p>
                            <p>{{ $t('lang.Website') }}：www.bawayft.com</p>
                        </a-col>
                        <a-col :span="8">
                            <img src="../../static/images/u656.png" alt="" style="width: 340px">
                        </a-col>
                    </a-row>
                    <div style="margin: 40px 0">
                        <iframe width="1000" height="460" frameborder='0' scrolling='no' marginheight='0'
                                marginwidth='0' src="https://surl.amap.com/2l5e5ZIrB4Gf"></iframe>
                    </div>
                </div>
                <div class="ClearFloat"></div>
            </div>
        </div>

    </div>
</template>
<script>
import navComponent from "@/components/navcomponents";

export default {
    name: "About",
    components: {
        navComponent
    },
    data() {
        return {
            locale: 'zh',
        }
    },
    mounted() {
        document.title = '贝威科技(潍坊)有限公司-联系我们'
        this.locale = localStorage.getItem("lang") || 'zh';
    }
}
</script>

<style scoped>
.name-top {
    font-size: 26px;
    margin-left: 20px;
    color: #3a8ee6;
}

.name-logo {
    width: 300px;
    margin-left: 40px;
}


.content-list p {
    font-weight: bold;
    line-height: 40px;
    font-size: 18px;
    margin-left: 40px;
}
</style>
